export const AUDIO_TYPE = {
  DEFAULT: '1',
  SWIFT_HERE: '2',
  ROBOT_HERE: '3'
}

export const AUDIO_SOURCE = {
  DEFAULT: require('../assets/notificationSound.mp3'),
  SWIFT_HERE: require('../assets/swift-here-sound.mp3'),
  ROBOT_HERE: require('../assets/robot-here-sound.mp3')
}